/** .pouches を 1 件選ぶ（Electron 以外の Web / PWA 用） */
export function pickPouchesFile(): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pouches,application/pouches,application/json';
    input.onchange = () => {
      resolve(input.files?.[0] ?? null);
    };
    input.oncancel = () => resolve(null);
    input.click();
  });
}
